const keyMirror = require('fbjs/lib/keyMirror');

module.exports = keyMirror({
  /*<editor-fold desc="[Application state actions]">*/
  APP_OPEN_POPOVER: null,
  APP_ERROR: null,
  APP_CHANGE_LANG: null,
  APP_LOAD_LANGUAGES: null,
  APP_PROFILE_SETTING_LOADED: null,
  APP_MODULE_STATE: null,
  APP_TOGGLE_GLOBAL_SPINNER: null,
  APP_TOGGLE_IN_PROGRESS_STATE: null,
  /*</editor-fold desc="[Application state actions]">*/

  APP_BANNER_SET_CONTENT: null,

  SECURITY_ERROR: null,
  SECURITY_RESET_PASSWORD: null,
  SECURITY_RESET_PASSWORD_TOKEN_VALIDATE: null,
  SECURITY_ACTIVATE_ACCOUNT_TOKEN_VALIDATE: null,
  SECURITY_NEW_PASSWORD_SAVED: null,
  SECURITY_ACTIVATE_ACCOUNT: null,


  FILE_UPLOAD_IMAGE_UPLOAD_SUCCESS: null,
  FILE_UPLOAD_IMAGE_UPLOAD_ERROR: null,
  FILE_UPLOAD_ERROR: null,
  FILE_UPLOAD_PROGRESS: null,
  AVATAR_ULPOAD_SUCCESS: null,


  HOME_ADD_WIDGET: null,
  HOME_DELETE_WIDGET: null,
  HOME_WIDGET_LIST_LOAD: null,

  MENU_INITIALIZE: null,
  MENU_ACTIVATE_ITEM: null,
  MENU_GET_MENU: null,
  MENU_INSPECTION_CENTRE_GET_FILTERS: null,

  NOTICE_INITIALIZE: null,

  NEWS_GET_NEWS: null,

  RECENTSESSIONS_GET_WIDGET: null,
  RECENTSESSIONS_GET_ASSESSMENTS: null,
  RECENT_SESSIONS_ASSESSMENTS_INITIALIZE: null,
  RECENT_SESSIONS_WIDGET_INITIALIZE: null,
  RECENT_SESSIONS_GET_ASSESSMENTS_DETAILS: null,

  LANGUAGES_INIT: null,
  LANGUAGES_SELECT: null,

  LEARNERS_GET_CLASS_DETAILS: null,
  LEARNERS_GET_LEARNERS_LIST: null,
  LEARNERS_GET_LEARNERS_LIST_BY_FILTER: null,
  LEARNERS_GET_LEARNER_ENTRY: null,
  LEARNERS_GET_ASSESSMENTS: null,
  LEARNERS_GET_TAGS: null,
  LEARNERS_CREATE_TAG: null,
  LEARNERS_CREATE_LEARNER: null,
  LEARNERS_UPDATE_LEARNER: null,
  LEARNERS_UPDATE_LEARNERS_YEAR_GROUPS: null,
  LEARNERS_UPDATE_LEARNER_FAILURE: null,
  LEARNERS_DELETE_LEARNER: null,
  LEARNERS_COPY_LEARNER: null,
  LEARNERS_MOVE_LEARNER: null,
  LEARNERS_IMPORT_PROGRESS: null,
  LEARNERS_IMPORT_SUCCESS: null,
  LEARNERS_IMPORT_ERROR: null,

  PARENTS_GET_PARENTS: null,
  PARENTS_ADD_NEW_PARENT: null,

  CLASSES_GET_CLASSES: null,
  CLASSES_PUT_CLASS: null,
  CLASSES_COPY_CLASS: null,
  CLASSES_COPY_GROUP: null,
  CLASSES_MOVE_CLASS: null,
  CLASSES_REPOSITION_CLASS: null,
  CLASSES_CREATE_CLASS: null,
  CLASSES_DELETE_CLASS: null,
  CLASSES_GET_CLASSES_POSSIBLE_TEACHERS: null,
  CLASSES_GET_CLASS_TEACHERS: null,


  MISCUE_SESSIONS_GET_RECENT: null,
  MISCUE_SESSIONS_GET_LATEST: null,
  MISCUE_SESSIONS_GET_ASSESSMENT_DETAILS: null,
  MISCUE_SESSIONS_PATCH_ASSESSMENT_NOTE_SUCCESS: null,
  MISCUE_SESSIONS_PATCH_ASSESSMENT_NOTE_ERROR: null,
  MISCUE_SESSIONS_PATCH_MISCUE: null,
  MISCUE_SESSIONS_DELETE: null,
  MISCUE_SESSIONS_DELETE_MISCUE: null,
  MISCUE_SESSIONS_GET_MISCUE_TYPES: null,
  MISCUE_SESSIONS_GET_MISCUE_YEAR_GROUPS: null,
  MISCUE_SESSIONS_GET_MISCUE_BOOK_BANDS: null,

  REPORT_GET_RA_REPORT: null,

  GET_2BAP_REPORT_TEMPLATES_DICTIONARY: null,
  CLEAR_2BAP_REPORT_TEMPLATES_DICTIONARY: null,

  /*<editor-fold desc="[ Profile Account actions ]">*/
  PROFILE_GET_ACCOUNT: null,
  PROFILE_CREATE_ACCOUNT: null,
  PROFILE_UPDATE_ACCOUNT: null,
  PROFILE_UPDATE_ACCOUNT_FAILURE: null,
	PROFILE_TOGGLE_UPLOAD_AVATAR_DIALOG: null,
  GET_ACCOUNT_PERMISSIONS: null,
  /*</editor-fold desc="[ Profile Account actions ]">*/

  MODULE_GET_LIST: null,
  MODULE_SET_CURRENT_MODULE: null,

  /*<editor-fold desc="[ Authentications actions ]">*/
  AUTH_SIGNIN: null,
  AUTH_LOGIN: null,
  AUTH_LOGOUT: null,
  AUTH_LOGIN_FAILURE: null,
  AUTH_LOGIN_SSO_FAILURE: null,
  AUTH_LOGIN_ACT_AS_FAILURE: null,
  AUTH_LOGIN_2BAP_EXTERNAL_START: null,
  AUTH_LOGIN_2BAP_EXTERNAL_END: null,
  AUTH_LOGOUT_ACT_AS: null,
  AUTH_ACT_AS: null,
  AUTH_ACT_AS_FAILURE: null,
  /*</editor-fold desc="[ Authentications actions ]">*/

  /*<editor-fold desc="[ Organisation actions ]">*/
  ORGANISATIONS_GET_ORGANISATION_LIST: null,
  ORGANISATIONS_GET_ORGANISATION_LIST_ITEM: null,
  ORGANISATIONS_GET_ORGANISATION: null,
  ORGANISATIONS_GET_ORGANISATION_QUESTIONNAIRES: null,
  ORGANISATIONS_SAVE_ORGANISATION_QUESTIONNAIRES: null,
  ORGANISATIONS_CLEAN_ORGANISATION_QUESTIONNAIRES: null,
  ORGANISATIONS_GET_ORGANISATION_FRAMEWORKS: null,
  ORGANISATIONS_CLEAN_ORGANISATION_FRAMEWORKS: null,
  ORGANISATIONS_SAVE_ORGANISATION_FRAMEWORKS: null,
  ORGANISATIONS_GET_MODULES: null,
  ORGANISATIONS_GET_MODULES_IS_LOADING: null,
  ORGANISATIONS_SAVE_MODULES: null,
  ORGANISATIONS_CREATE_ORGANISATION: null,
  ORGANISATIONS_UPDATE_ORGANISATION: null,
  ORGANISATIONS_SELECT_CURRENT: null,
  ORGANISATIONS_SAVE_ERROR: null,
  ORGANISATIONS_GET_ROLE_LIST: null,
  ORGANISATIONS_GET_SALE_SOURCES: null,
  ORGANISATIONS_GET_ORGANISATION_LOOKUP_LIST: null,
  /*</editor-fold desc="[ Organisation actions ]">*/

  GET_ORGANISATION_SETTINGS: null,

  /*<editor-fold desc="[ User actions ]">*/
  USERS_GET_USER_LIST: null,
  USERS_GET_USER: null,
  USERS_GET_ORGANISATION_USER: null,
  USERS_GET_CURRENT_ORGANISATION_USERS: null,
  USERS_GET_CURRENT_ORGANISATION_ADMINISTRATIVE_USERS: null,
  USERS_CREATE_USER: null,
  USERS_UPDATE_USER: null,
  USERS_UPDATE_USER_FAILURE: null,
  USERS_ACT_AS: null,
  /*</editor-fold desc="[ User actions ]">*/

  /*<editor-fold desc="[ Report gen actions ]">*/
  REPORT_PDF_RA_SUCCESS: null,
  REPORT_PDF_RA_ERROR: null,
  REPORT_PDF_GET_YEAR_GROUP_EXPECTED_PROGRESS: null,
  REPORT_PDF_GET_LEARNER_PORTFOLIO: null,
  /*</editor-fold desc="[ Report gen actions ]">*/

  /*<editor-fold desc="[ Schools related actions ]">*/
  SCHOOLS_GET_SCHOOL_LIST: null,
  SCHOOLS_GET_BOOK_PACK_LIST: null,
  SCHOOLS_BOOK_PACK_LIST_SAVED: null,
  /*</editor-fold desc="[ Schools ]">*/

  /*<editor-fold desc="[ Activity log actions ]">*/
  ACTIVITY_LOG_GET_ACTIVITY_LIST: null,
  /*</editor-fold desc="[ Activity log actions ]">*/

  ADMIN_QUESTIONNAIRES_GET_QUESTIONNAIRES_LIST: null,
  ADMIN_QUESTIONNAIRES_CLEAN_SELECTION: null,
  ADMIN_QUESTIONNAIRES_CLEAN_QUESTION_AND_SIP_LIST: null,
  ADMIN_QUESTIONNAIRES_CLEAN_QUESTION_AND_SIP_SELECTION: null,
  ADMIN_QUESTIONNAIRES_SELECT_QUESTIONNAIRE: null,
  ADMIN_QUESTIONNAIRES_CREATE_QUESTIONNAIRE: null,
  ADMIN_QUESTIONNAIRES_UPDATE_QUESTIONNAIRE: null,
  ADMIN_QUESTIONNAIRES_REMOVE_QUESTIONNAIRE: null,
  ADMIN_QUESTIONNAIRES_GET_QUESTIONNAIRE: null,
  ADMIN_QUESTIONNAIRES_GET_QUESTIONNAIRE_SECTIONS: null,
  ADMIN_QUESTIONNAIRES_CREATE_QUESTIONNAIRE_SECTION: null,
  ADMIN_QUESTIONNAIRES_SET_FORM_ERRORS: null,
  ADMIN_QUESTIONNAIRES_CLEAN_FORM_ERRORS: null,

  ADMIN_TOPICS_GET_TOPICS_LIST: null,
  ADMIN_TOPICS_GET_TOPIC: null,
  ADMIN_TOPICS_CREATE_TOPIC: null,
  ADMIN_TOPICS_UPDATE_TOPIC: null,
  ADMIN_TOPICS_DELETE_TOPIC: null,
  ADMIN_TOPICS_SELECT_TOPIC: null,
  ADMIN_TOPICS_SELECT_IMAGE: null,
  ADMIN_TOPICS_SELECT_FILTER_SECTION: null,
  ADMIN_TOPICS_SET_FORM_ERRORS: null,
  ADMIN_TOPICS_CLEAN_FORM_ERRORS: null,
  ADMIN_TOPICS_SAVE_FILE_FOR_CURRENT_FORM: null,
  ADMIN_TOPICS_CHANGE_TOPIC_ORDER: null,

  ADMIN_QUESTIONS_SELECT_QUESTION: null,
  ADMIN_QUESTIONS_GET_QUESTIONS_LIST: null,
  ADMIN_QUESTIONS_CLEAN_QUESTIONS_LIST: null,
  ADMIN_QUESTIONS_CLEAN_FORM_ERRORS: null,
  ADMIN_QUESTIONS_GET_QUESTION: null,
  ADMIN_QUESTIONS_CREATE_QUESTION: null,
  ADMIN_QUESTIONS_UPDATE_QUESTION: null,
  ADMIN_QUESTIONS_DELETE_QUESTION: null,
  ADMIN_QUESTIONS_CHANGE_QUESTION_ORDER: null,
  ADMIN_QUESTIONS_ADD_ANSWER: null,
  ADMIN_QUESTIONS_DELETE_ANSWER: null,
  ADMIN_QUESTIONS_CHANGE_ANSWER_ORDER: null,
  ADMIN_QUESTIONS_SET_FORM_ERRORS: null,
  ADMIN_QUESTIONS_GENERATE_QUESTION_FOR_EDITING: null,

  ADMIN_SIP_GET_SIP_ACTIONS: null,
  ADMIN_SIP_GET_ALL_SIP_ACTIONS: null,
  ADMIN_SIP_GET_SIP_ACTIONS_IS_LOADING: null,
  ADMIN_SIP_GET_SIP_ACTION: null,
  ADMIN_SIP_CREATE_SIP_ACTION: null,
  ADMIN_SIP_UPDATE_SIP_ACTION: null,
  ADMIN_SIP_DELETE_SIP_ACTION: null,
  ADMIN_SIP_SELECT_SIP_ACTIONS: null,
  ADMIN_SIP_SET_FORM_ERRORS: null,
  ADMIN_SIP_CLEAN_FORM_ERRORS: null,

  ADMIN_GET_PLANS: null,
  ADMIN_GET_PLANS_IS_LOADING: null,
  ADMIN_CREATE_PLANS: null,
  ADMIN_UPDATE_PLANS: null,
  ADMIN_SELECT_PLAN: null,
  ADMIN_SET_MODAL_ADD_PLAN: null,
  ADMIN_SET_MODAL_EDIT_PLAN: null,
  ADMIN_SET_PLAN_FORM_ERRORS: null,

  ADMIN_CONFIGURE_PLAN_TASK_REPORT_LOADING: null,
  ADMIN_CONFIGURE_PLAN_SET_TASK_REPORT: null,
  ADMIN_CONFIGURE_PLAN_SET_PLAN_COLUMNS: null,

  ADMIN_LEARNING_FRAMEWORKS_GET_FRAMEWORKS_LIST: null,
  ADMIN_LEARNING_FRAMEWORKS_GET_FRAMEWORK: null,
  ADMIN_LEARNING_FRAMEWORKS_SELECT_FRAMEWORK: null,
  ADMIN_LEARNING_FRAMEWORKS_CHANGE_FRAMEWORKS_ORDER: null,
  ADMIN_LEARNING_FRAMEWORKS_DELETE_FRAMEWORK: null,
  ADMIN_LEARNING_FRAMEWORKS_GET_OBJECTIVE_LEVEL_SCHEME: null,
  ADMIN_LEARNING_FRAMEWORKS_GET_ASSESSMENT_SCHEME: null,
  ADMIN_LEARNING_FRAMEWORKS_GENERATE_FRAMEWORK_FOR_EDITING: null,
  ADMIN_LEARNING_FRAMEWORKS_ADD_ASSESSMENT: null,
  ADMIN_LEARNING_FRAMEWORKS_DELETE_ASSESSMENT: null,
  ADMIN_LEARNING_FRAMEWORKS_DELETE_OLD_ASSESSMENT: null,
  ADMIN_LEARNING_FRAMEWORKS_CHANGE_ASSESSMENT_ORDER: null,
  ADMIN_LEARNING_FRAMEWORKS_SHOW_ERROR_NOTIFICATION: null,

  ADMIN_FRAMEWORK_CATEGORIES_GET_CATEGORIES: null,
  ADMIN_FRAMEWORK_CATEGORIES_CLEAR_CATEGORIES: null,
  ADMIN_FRAMEWORK_CATEGORIES_SELECT_CATEGORY: null,

  ADMIN_FRAMEWORK_OBJECTIVES_GET_OBJECTIVES: null,
  ADMIN_FRAMEWORK_CATEGORIES_CLEAR_OBJECTIVES: null,
  ADMIN_FRAMEWORK_CATEGORIES_REORDER_OBJECTIVES: null,
  ADMIN_FRAMEWORK_CATEGORIES_SELECT_OBJECTIVE: null,
  ADMIN_FRAMEWORK_CATEGORIES_SELECT_OBJECTIVE_LEVEL: null,

  ADMIN_OBSERVATION_NOTES_GET_NOTES: null,
  ADMIN_OBSERVATION_NOTES_SELECT_NOTE: null,
  ADMIN_OBSERVATION_NOTES_CHANGE_NOTES_ORDER: null,
  ADMIN_OBSERVATION_NOTES_CHANGE_NOTES_CLEAR: null,

  ADMIN_OBSERVATION_OBJECTIVES_SET_PARENT_OBJECTIVES_VISIBILITY_SETTING: null,
  ADMIN_OBSERVATION_OBJECTIVES_SET_NEXT_STEP_OBJECTIVES_VISIBILITY_SETTING: null,

  ADMIN_REPORT_TEMPLATES_GET_TEMPLATES: null,
  ADMIN_REPORT_TEMPLATES_GET_DEFAULT_LEARNER_OBSERVATION_TEACHER_LINK: null,
  ADMIN_REPORT_TEMPLATES_GET_DEFAULT_LEARNER_OBSERVATION_PARENT_LINK: null,
  ADMIN_REPORT_TEMPLATES_CLEAR_TEMPLATES: null,

  ADMIN_ASSESSMENT_SELECT_ASSESSMENT_SCHEME: null,
  ADMIN_ASSESSMENT_GET_ASSESSMENT_SCHEMES: null,
  ADMIN_ASSESSMENT_GET_ASSESSMENT_SCHEME_DETAILS: null,
  ADMIN_ASSESSMENT_CLEAR_ASSESSMENT_SCHEME_DETAILS: null,
  ADMIN_ASSESSMENT_SAVE_ASSESSMENT_SCHEME: null,
  ADMIN_ASSESSMENT_CLEAR_PAGE: null,

  INSPECTION_COACH_SHOW_ERROR_NOTIFICATION: null,
  INSPECTION_COACH_CLOSE_MODALS: null,
  INSPECTION_COACH_OPEN_MODAL_COMMON: null,
  INSPECTION_COACH_OPEN_MODAL_ADD_QUESTIONNAIRE: null,
  INSPECTION_COACH_OPEN_MODAL_EDIT_QUESTIONNAIRE: null,
  INSPECTION_COACH_OPEN_MODAL_DELETE_QUESTIONNAIRE: null,
  INSPECTION_COACH_OPEN_MODAL_ADD_TOPIC: null,
  INSPECTION_COACH_OPEN_MODAL_EDIT_TOPIC: null,
  INSPECTION_COACH_OPEN_MODAL_DELETE_TOPIC: null,
  INSPECTION_COACH_SET_UPLOAD_FILE_TOPIC_MODAL: null,
  INSPECTION_COACH_SET_UPLOAD_VIDEO_TOPIC_MODAL: null,
  INSPECTION_COACH_OPEN_MODAL_ADD_QUESTION: null,
  INSPECTION_COACH_OPEN_MODAL_EDIT_QUESTION: null,
  INSPECTION_COACH_OPEN_MODAL_DELETE_QUESTION: null,
  INSPECTION_COACH_OPEN_MODAL_ADD_SIP_ACTION: null,
  INSPECTION_COACH_OPEN_MODAL_EDIT_SIP_ACTION: null,
  INSPECTION_COACH_OPEN_MODAL_DELETE_SIP_ACTION: null,

  INSPECTION_COACH_MODULE_GET_QUESTIONNAIRES_LIST: null,
  INSPECTION_COACH_MODULE_GET_QUESTIONNAIRE_TEMPLATES_LIST: null,
  INSPECTION_COACH_MODULE_START_NEW_UPDATE_QUESTIONNAIRE_NAME: null,
  INSPECTION_COACH_MODULE_QUESTIONNAIRES_SET_FORM_ERRORS: null,
  INSPECTION_COACH_MODULE_QUESTIONNAIRES_CLEAN_FORM_ERRORS: null,
  INSPECTION_COACH_MODULE_SELECT_QUESTIONNAIRE: null,
  INSPECTION_COACH_MODULE_HOME_SELECT_QUESTIONNAIRE: null,
  INSPECTION_COACH_MODULE_CLEAN_QUESTIONNAIRE: null,
  INSPECTION_COACH_MODULE_CLOSE_MODALS: null,
  INSPECTION_COACH_MODULE_OPEN_MODAL_EDIT_QUESTIONNAIRE: null,
  INSPECTION_COACH_MODULE_OPEN_MODAL_START_NEW_QUESTIONNAIRE: null,
  INSPECTION_COACH_MODULE_GET_TOPIC: null,
  INSPECTION_COACH_MODULE_GET_TOPIC_JUDGEMENT_RESULT: null,
  INSPECTION_COACH_MODULE_GET_TOPIC_IS_LOADING: null,
  INSPECTION_COACH_MODULE_SAVE_TOPIC_PAGE_DATA: null,
  INSPECTION_COACH_MODULE_SAVE_JUDGEMENT_FOR_APPROVE: null,
  INSPECTION_COACH_MODULE_PROVE_JUDGEMENT: null,
  INSPECTION_COACH_MODULE_SELECT_TAB: null,
  INSPECTION_COACH_MODULE_GET_QUESTIONS: null,
  INSPECTION_COACH_MODULE_GET_QUESTIONS_IS_LOADING: null,
  INSPECTION_COACH_MODULE_GET_QUESTION_NOTE: null,
  INSPECTION_COACH_MODULE_SET_QUESTION_NOTE: null,
  INSPECTION_COACH_MODULE_SET_TOPIC_NOTE_ERRORS: null,
  INSPECTION_COACH_MODULE_SAVE_FILE: null,
  INSPECTION_COACH_MODULE_DELETE_FILE: null,
  INSPECTION_COACH_MODULE_SELECT_QUESTION: null,
  INSPECTION_COACH_MODULE_UPDATE_QUESTION: null,
  INSPECTION_COACH_MODULE_UPDATE_QUESTION_SKIP_STATE: null,
  INSPECTION_COACH_MODULE_ADD_ANSWER_TO_SIP: null,
  INSPECTION_COACH_MODULE_GET_TASKS_FOR_SIP: null,
	INSPECTION_COACH_MODULE_SET_SIP_TASKS_ERROR: null,

  INSPECTION_COACH_MODULE_TOPIC_CLOSE_MODALS: null,
  INSPECTION_COACH_MODULE_TOPIC_OPEN_MODAL_ADD_NOTES: null,
  INSPECTION_COACH_MODULE_TOPIC_OPEN_MODAL_ADD_SIP: null,
  INSPECTION_COACH_MODULE_TOPIC_OPEN_MODAL_ADD_FILES: null,

  INSPECTION_COACH_MODULE_GET_SECTIONS_AND_TOPICS: null,
  INSPECTION_COACH_MODULE_SECTIONS_AND_TOPICS_ENABLE_SPINNER: null,
  INSPECTION_COACH_MODULE_SECTIONS_AND_TOPICS_DISABLE_SPINNER: null,

  INSPECTION_COACH_MODULE_GET_SELF_EVALUATION_NOTES: null,
  INSPECTION_COACH_MODULE_UPDATE_SELF_EVALUATION_NOTES: null,
  INSPECTION_COACH_MODULE_SELF_EVALUATION_NOTES_IS_LOADING: null,
  INSPECTION_COACH_MODULE_GET_SELF_EVALUATION_REPORT: null,
  INSPECTION_COACH_MODULE_CLEAR_SELF_EVALUATION_REPORT: null,
  INSPECTION_COACH_MODULE_SELF_EVALUATION_REPORT_IS_LOADING: null,
  INSPECTION_COACH_MODULE_GET_SELF_EVALUATION_SECTIONS: null,
  INSPECTION_COACH_MODULE_CLEAR_SELF_EVALUATION_SECTIONS: null,

  INSPECTION_CENTRE_MODULE_GET_INSPECTION_CENTRE_PLANS: null,
  INSPECTION_CENTRE_MODULE_SELECT_INSPECTION_CENTRE_PLAN: null,
  INSPECTION_CENTRE_MODULE_GET_INSPECTION_CENTRE_PLANS_IS_LOADING: null,
  INSPECTION_CENTRE_MODULE_GET_PLAN_COLUMNS: null,
  INSPECTION_CENTRE_MODULE_GET_PLAN_COLUMN: null,
  INSPECTION_CENTRE_MODULE_GET_PLAN_COLUMNS_IS_LOADING: null,
  INSPECTION_CENTRE_MODULE_CHANGE_COLUMNS_ORDER: null,
  INSPECTION_CENTRE_MODULE_SELECT_COLUMN: null,
  INSPECTION_CENTRE_MODULE_SET_MODAL_ADD_COLUMN: null,
  INSPECTION_CENTRE_MODULE_SET_MODAL_EDIT_COLUMN: null,
  INSPECTION_CENTRE_MODULE_SET_COLUMN_FORM_ERRORS: null,

  INSPECTION_CENTRE_SHOW_ERROR_NOTIFICATION: null,
  INSPECTION_CENTRE_SHOW_SUCCESS_NOTIFICATION: null,
  INSPECTION_CENTRE_TASK_REPORT_EXPORT_SUCCESS: null,
  INSPECTION_CENTRE_MODULE_GET_FILTER_LOOKUPS: null,
  INSPECTION_CENTRE_MODULE_GET_FILTERS: null,
  INSPECTION_CENTRE_MODULE_GET_FILTERS_IS_LOADING: null,
  INSPECTION_CENTRE_MODULE_SELECT_FILTER: null,
  INSPECTION_CENTRE_MODULE_FILTER_PAGE_SET_MODAL_ADD_FILTER: null,
  INSPECTION_CENTRE_MODULE_FILTER_PAGE_SET_MODAL_EDIT_FILTER: null,
  INSPECTION_CENTRE_MODULE_FILTER_PAGE_SET_MODAL_DELETE_FILTER: null,
  INSPECTION_CENTRE_MODULE_GET_FILTER: null,
  INSPECTION_CENTRE_MODULE_GET_FILTER_FOR_TASK: null,
  INSPECTION_CENTRE_MODULE_SET_AD_HOC_FILTER_FOR_TASK: null,
  INSPECTION_CENTRE_MODULE_SET_STATS_BY_FILTER: null,
  INSPECTION_CENTRE_MODULE_SET_STATS_BY_ID: null,
  INSPECTION_CENTRE_MODULE_GET_USERS: null,
  INSPECTION_CENTRE_MODULE_SET_FILTER_FORM_ERRORS: null,

  INSPECTION_CENTRE_MODULE_GET_TASKS:null,
  INSPECTION_CENTRE_MODULE_GET_TASKS_IS_LOADING: null,
  INSPECTION_CENTRE_MODULE_GET_TASK: null,
  INSPECTION_CENTRE_MODULE_GET_SUB_TASK: null,
  INSPECTION_CENTRE_MODULE_CREATE_TASK: null,
  INSPECTION_CENTRE_MODULE_UPDATE_TASK: null,
  INSPECTION_CENTRE_MODULE_GET_TASK_HISTORY: null,
  INSPECTION_CENTRE_MODULE_GET_TASK_HISTORY_IS_LOADING: null,
  INSPECTION_CENTRE_MODULE_GET_TASK_COMMENTS: null,
  INSPECTION_CENTRE_MODULE_GET_TASK_COMMENTS_IS_LOADING: null,
  INSPECTION_CENTRE_MODULE_GET_TASK_ATTACHMENTS: null,
  INSPECTION_CENTRE_MODULE_SAVE_TASK_ATTACHMENT: null,
  INSPECTION_CENTRE_MODULE_DELETE_TASK_ATTACHMENT: null,
  INSPECTION_CENTRE_MODULE_GET_TASK_ATTACHMENTS_IS_LOADING: null,
  INSPECTION_CENTRE_MODULE_SAVE_TASK_COMMENT: null,
  INSPECTION_CENTRE_MODULE_TASKS_PAGE_SET_MODAL_ADD_TASK: null,
  INSPECTION_CENTRE_MODULE_TASK_PAGE_SET_MODAL_EDIT_TASK: null,
  INSPECTION_CENTRE_MODULE_TASK_PAGE_SET_MODAL_DELETE_TASK: null,
	INSPECTION_CENTRE_MODULE_TASK_PAGE_SET_MODAL_CLOSE: null,
  INSPECTION_CENTRE_MODULE_TASK_PAGE_SET_MODAL_ADD_FILES: null,
  INSPECTION_CENTRE_MODULE_TASK_PAGE_SET_MODAL_ADD_SUB_TASK: null,
  INSPECTION_CENTRE_MODULE_TASKS_PAGE_SET_MODAL_EDIT_FILTER: null,
  INSPECTION_CENTRE_MODULE_SET_TASK_FORM_ERRORS: null,
  INSPECTION_CENTRE_MODULE_SET_TASK_TAB: null,

  VIDEO_CONVERTED_SUCCESS: null,
  VIDEO_CONVERTED_ERROR: null,
	UPDATE_FILE_MODEL: null,

  SHOW_SUCCESS_NOTIFICATION: null,
  SHOW_ERROR_NOTIFICATION: null,
  SHOW_INFO_NOTIFICATION: null,
  SHOW_WARNING_NOTIFICATION: null,

  BUILD_A_PROFILE_MODULE_EXTERNAL_REPORTS_PAGE_UPDATE_FILTERS: null,
  BUILD_A_PROFILE_MODULE_EXTERNAL_REPORTS_PAGE_SET_ERROR: null,
  BUILD_A_PROFILE_MODULE_EXTERNAL_REPORTS_PAGE_SET_FILTERS_LOADING: null,
  BUILD_A_PROFILE_MODULE_EXTERNAL_REPORTS_PAGE_SET_REPORTS_LOADING: null,

  BUILD_A_PROFILE_MODULE_REPORTS_PAGE_UPDATE_REPORT_STATUS: null,

  BUILD_A_PROFILE_MODULE_REPORTS_LIST_PAGE_GET_REPORT_CATEGORIES: null,
  BUILD_A_PROFILE_MODULE_REPORTS_LIST_PAGE_GET_REPORTS_LIST_BY_CATEGORY: null,
  BUILD_A_PROFILE_MODULE_REPORTS_LIST_PAGE_GET_GLOBAL_REPORTS_LIST: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATION_REPORTS_GENERATION_START: null,
  REPORTS_GENERATION_REPORTS_NOTIFICATION_SUCCESS: null,

  BUILD_A_PROFILE_MODULE_REPORTS_GENERATION_REPORTS_NOTIFICATION_SUCCESS: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATION_REPORTS_NOTIFICATION_ERROR: null,

  BUILD_A_PROFILE_MODULE_REPORTS_GENERATE_PAGE_SET_FILTER: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATE_PAGE_SET_DATASET: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATE_PAGE_DELETE_DATASET: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATE_PAGE_CLEAR_PAGE: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATE_PAGE_GET_DEFAULT_FILTER: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATE_PAGE_GET_CONFIG: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATE_PAGE_GET_REPORT_TEMPLATES: null,

  BUILD_A_PROFILE_MODULE_GET_OBSERVATIONS_COUNT_MESSAGE: null,
  BUILD_A_PROFILE_MODULE_SET_LOADING_OBSERVATIONS_COUNT_MESSAGE: null,

  // TODO: move modals state to components and remove these actions
  BUILD_A_PROFILE_AND_FRAMEWORKS_LEARNING_FRAMEWORKS_OPEN_MODAL_DELETE_FRAMEWORK: null,
  BUILD_A_PROFILE_AND_FRAMEWORKS_LEARNING_FRAMEWORKS_OPEN_MODAL_EDIT_FRAMEWORK: null,
  BUILD_A_PROFILE_AND_FRAMEWORKS_LEARNING_FRAMEWORKS_OPEN_MODAL_ADD_FRAMEWORK: null,
  BUILD_A_PROFILE_AND_FRAMEWORKS_LEARNING_FRAMEWORKS_CLOSE_MODALS: null,

  ADMIN_LEARNING_FRAMEWORKS_CLEAR_FRAMEWORKS: null,

  BUILD_A_PROFILE_MODULE_FRAMEWORK_ACTIONS_GET_FRAMEWORKS: null,
  BUILD_A_PROFILE_MODULE_FRAMEWORK_ACTIONS_GET_CATEGORIES: null,
  BUILD_A_PROFILE_MODULE_FRAMEWORK_ACTIONS_GET_OBJECTIVE_LEVELS: null,
  BUILD_A_PROFILE_MODULE_FRAMEWORK_ACTIONS_CLEAR_DATA: null,

  BUILD_A_PROFILE_MODULE_LEARNER_ACTIONS_GET_CLASSES: null,
  BUILD_A_PROFILE_MODULE_LEARNER_ACTIONS_GET_LEARNERS: null,
  BUILD_A_PROFILE_MODULE_LEARNER_ACTIONS_GET_TAGS: null,
  BUILD_A_PROFILE_MODULE_LEARNER_ACTIONS_GET_YEAR_GROUPS: null,
  BUILD_A_PROFILE_MODULE_LEARNER_ACTIONS_CLEAR_DATA: null,
  BUILD_A_PROFILE_MODULE_LEARNER_ACTIONS_CLEAR_CLASSES: null,

  BUILD_A_PROFILE_MODULE_LEARNER_PORTFOLIO_GET_LEARNER: null,

  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAIL_GET_OBSERVATION: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAIL_GET_OBSERVATION_LEARNERS: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAIL_SELECT_OBSERVATION_FILE: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAIL_UPLOAD_ROTATED_FILE: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAIL_CLEAR_PAGE: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAIL_GET_SCHOOL_NOTES: null,

  BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_GET_CLASSES: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_SELECT_TAB: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_SELECT_CLASS: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_GET_LEARNERS: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_UPDATE_LEARNER: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_SELECT_LEARNER: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_CLEAR_OBSERVATIONS_FOR_RELEASE_LEARNERS: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_CLEAR_PAGE_DATA: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_CLEAR_DATA: null,

  BUILD_A_PROFILE_MODULE_OBSERVATIONS_RELEASE_GET_LEARNERS: null,
  BUILD_A_PROFILE_MODULE_OBSERVATIONS_RELEASE_SELECT_LEARNER: null,
  BUILD_A_PROFILE_MODULE_OBSERVATIONS_RELEASE_SET_LEARNERS_FILTER: null,
  BUILD_A_PROFILE_MODULE_OBSERVATIONS_RELEASE_SET_DEFAULT_LEARNERS_FILTER: null,
  BUILD_A_PROFILE_MODULE_OBSERVATIONS_RELEASE_CLEAR_LEARNERS_FILTER: null,
  BUILD_A_PROFILE_MODULE_OBSERVATIONS_RELEASE_CLEAR_DATA: null,
  BUILD_A_PROFILE_MODULE_OBSERVATIONS_RELEASE_CLEAR_DATA_EXCLUDING_SELECTED_LEARNER: null,

  BUILD_A_PROFILE_MODULE_ASSESSMENT_APPLY_FILTER: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_GET_TREE: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_GET_LEARNERS: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_GET_ASSESSMENTS: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_TOGGLE_CATEGORY: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_CLEAR_ASSESSMENTS: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_ADD_SHORTCUT: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_UPDATE_TOP_LEVEL_CATEGORY_ASSESSMENTS: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_GET_ASSESSMENT_PERIODS: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_COLLAPSE_ALL_NODES: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_DELETE_CATEGORY: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_UPDATE_PERIOD_NOTES: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENT_SET_JUDGEMENT_FILE__URL: null,

  BUILD_A_PROFILE_GET_FILTERED_OBJECTIVES: null,
  BUILD_A_PROFILE_CLEAR_FILTERED_OBJECTIVES: null,
  BUILD_A_PROFILE_SET_SCHOOL_OBJECTIVES_FILTER: null,

  BUILD_A_PROFILE_GET_OBSERVATION_ACTIVITIES: null,
  BUILD_A_PROFILE_CLEAR_OBSERVATION_ACTIVITIES_LIST: null,

  BUILD_A_PROFILE_MODULE_EXTERNAL_PROFILES_GET_CLASSES: null,
  BUILD_A_PROFILE_MODULE_EXTERNAL_PROFILES_SELECT_CLASS: null,
  BUILD_A_PROFILE_MODULE_EXTERNAL_PROFILES_GET_LEARNERS: null,
  BUILD_A_PROFILE_MODULE_EXTERNAL_PROFILES_GET_LEARNERS_NOTIFICATIONS: null,
  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_UPDATE_ASSESSMENTS: null,
  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_GO_BACK: null,
  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_GO_TO_CATEGORY: null,
  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_APPLY_FILTERS: null,
  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_CLEAR_ASSESSMENTS: null,
  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_REMOVE_FILTER: null,
  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_GET_OBSERVATIONS: null,
  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_GET_JUDGEMENTS_DATA: null,
  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_SHOW_MORE_ASSESSMENT_PERIODS: null,

  BUILD_A_PROFILE_MODULE_EXTERNAL_LEARNERS_GET_LEARNERS: null,
  BUILD_A_PROFILE_MODULE_EXTERNAL_LEARNERS_SEND_ARRIVAL_NOTIFICATION: null,
  BUILD_A_PROFILE_MODULE_EXTERNAL_LEARNERS_CLEAR_LEARNERS_DATA: null,

  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_CLEAR_JUDGEMENTS_DATA: null,

  BUILD_A_PROFILE_PROFILES_MODULE_LEARNER_ASSESSMENTS_SET_FRAMEWORK_SETTINGS: null,

  OBSERVATION_TAGS_GET_TAGS: null,
  OBSERVATION_TAGS_CLEAR_TAGS: null,

  CUSTOM_MODULE_GET_MODULE_CONTENT: null,
  CUSTOM_MODULE_CLEAR_MODULE_CONTENT: null,

});
